import React, { Component } from 'react';
import Header from 'components/layout/Partials/Header';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Loading from 'components/common/Loading';
import * as Icon from 'react-feather';
import TextFieldGroup from 'components/common/TextFieldGroup';
import { ToastsStore } from 'react-toasts';
import { logoutUser, setCurrentUser } from 'redux/actions/authActions';
import { Theme } from 'utils/Theme';
import { withStyles } from '@material-ui/styles';
import AnalyticsLayout from 'components/layout/AnalyticsLayout';
import api from 'api';
import AzureLink from './AzureLink';
import Box from '@material-ui/core/Box';
import config from 'coeus.config';

const styles = Theme();

class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            password: '',
            newPassword: '',
            confirmPassword: '',
        };
    }

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    resetPassword = (e) => {
        e.preventDefault();
        const passwordData = {
            password: this.state.password,
            newPassword: this.state.newPassword,
            confirmPassword: this.state.confirmPassword,
        };

        api.users
            .changePassword(passwordData)
            .then((_) => {
                ToastsStore.success('Password change successful');
                this.setState({
                    password: '',
                    newPassword: '',
                    confirmPassword: '',
                    errors: {},
                });
            })
            .catch((err) => {
                if (err?.status === 400) {
                    this.setState({ errors: err?.data });
                }
            });
    };

    render() {
        const { loading, errors } = this.state;
        const {
            classes,
            auth: { profile },
        } = this.props;

        return (
            <AnalyticsLayout>
                <div className="o-page">
                    <Header title="My Account" />
                    {profile === null ? (
                        <Loading />
                    ) : (
                        <div className="container u-mt-small">
                            <div className="row">
                                <div className="col-md-5">
                                    <div className="c-card">
                                        <div className="u-text-center">
                                            <div className="c-avatar c-avatar--large u-mb-small u-inline-flex">
                                                <span className="c-icon c-icon--large c-icon--primary u-mb-small">
                                                    <Icon.UserCheck
                                                        color={'white'}
                                                    />
                                                </span>
                                            </div>

                                            <h5>{profile.name}</h5>
                                            <p>
                                                {profile.directory}/
                                                {profile.qsId}
                                            </p>
                                        </div>

                                        <span className="c-divider u-mv-small"></span>

                                        <span className="c-text--subtitle">
                                            Email Address
                                        </span>
                                        <p className="u-mb-small u-text-large">
                                            {profile.email}
                                        </p>

                                        <span className="c-text--subtitle">
                                            Role
                                        </span>
                                        <p className="u-mb-small u-text-large">
                                            {profile.role}
                                        </p>

                                        <span className="c-text--subtitle u-block">
                                            Status
                                        </span>
                                        <span
                                            className={`c-badge u-mt-small c-badge--small ${classes.badgePrimary} u-mb-xsmall`}
                                        >
                                            {profile.active
                                                ? 'Active'
                                                : 'In Active'}
                                        </span>
                                        {config.feature.sso_azure.enabled && (
                                            <>
                                                <span className="c-text--subtitle u-block">
                                                    Link Azure account
                                                </span>
                                                <Box pt={1}>
                                                    <AzureLink
                                                        profile={profile}
                                                    />
                                                </Box>
                                            </>
                                        )}
                                    </div>
                                </div>

                                <div className="col-md-7">
                                    <nav className="c-tabs">
                                        <div
                                            className="c-tabs__list nav nav-tabs"
                                            id="myTab"
                                            role="tablist"
                                        >
                                            <a
                                                className="c-tabs__link active"
                                                id="nav-home-tab"
                                                data-toggle="tab"
                                                href="#nav-home"
                                                role="tab"
                                                aria-controls="nav-home"
                                                aria-selected="true"
                                            >
                                                Change Password
                                            </a>
                                        </div>
                                        <div
                                            className="c-tabs__content tab-content"
                                            id="nav-tabContent"
                                        >
                                            <div
                                                className="c-tabs__pane active"
                                                id="nav-home"
                                                role="tabpanel"
                                                aria-labelledby="nav-home-tab"
                                            >
                                                <p className={'u-mb-medium'}>
                                                    Strong password required.
                                                    Password must be at least 12
                                                    characters, with at lease 1
                                                    uppercase letters, 1
                                                    lowercase letters, numbers
                                                    and symbols. Do not include
                                                    common words or names.
                                                </p>
                                                <form
                                                    onSubmit={
                                                        this.resetPassword
                                                    }
                                                    noValidate
                                                >
                                                    <TextFieldGroup
                                                        label="Old Password"
                                                        type="password"
                                                        onChange={this.onChange}
                                                        value={
                                                            this.state.password
                                                        }
                                                        error={errors.password}
                                                        name="password"
                                                    />
                                                    <TextFieldGroup
                                                        label="New Password"
                                                        type="password"
                                                        onChange={this.onChange}
                                                        value={
                                                            this.state
                                                                .newPassword
                                                        }
                                                        error={
                                                            errors.newPassword
                                                        }
                                                        name="newPassword"
                                                    />
                                                    <TextFieldGroup
                                                        label="Confirm Password"
                                                        type="password"
                                                        onChange={this.onChange}
                                                        error={
                                                            errors.confirmPassword
                                                        }
                                                        value={
                                                            this.state
                                                                .confirmPassword
                                                        }
                                                        name="confirmPassword"
                                                    />
                                                    <button
                                                        type={'submit'}
                                                        className={`c-btn ${classes.buttonPrimary} u-mb-xsmall has-arrow`}
                                                    >
                                                        Change Password
                                                    </button>
                                                    <p>
                                                        Changes made to your
                                                        password will take
                                                        effect from your next
                                                        login.
                                                    </p>
                                                </form>
                                            </div>
                                        </div>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </AnalyticsLayout>
        );
    }
}

Profile.propTypes = {
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    logoutUser: PropTypes.func.isRequired,
    setCurrentUser: PropTypes.func.isRequired,
    classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    errors: state.errors,
});
export default connect(mapStateToProps, { logoutUser, setCurrentUser })(
    withRouter(withStyles(styles)(Profile))
);
